import { useContext } from "react";
import { LangDirectionContext } from "../../context/LangDirectionContext";

export function useLangDirection() {
  return useContext(LangDirectionContext);
}
